import { gql } from "@apollo/client";

const GET_TRAINEESHIP_PDF = gql`
  query traineeshipPdf($ID: String!) {
    traineeshipPdf(ID: $ID) {
      file
    }
  }
`;

export default GET_TRAINEESHIP_PDF;